export default class OrderSidebarService {
  constructor(UiService) {
    this.UiService = UiService;
    this.stocklist_data = {has_stocklist: false, css: 'error'};
    this.booking_notes_data = {has_booking_notes: false, css: 'error'};
    this.payment_general_data = {percentage: 0, css: 'red'};
    this.delivery_general_data = {percentage: 0, css: 'red'};
    this.main_infos_data = {percentage: 0, css: 'red'};
  }

  get_stocklist_data() {
    return this.stocklist_data;
  }

  set_stocklist_data(value) {
    this.stocklist_data.has_stocklist = value;
    this.stocklist_data.css = this.UiService.get_icon_css_class(value);
  }

  get_booking_notes_data() {
    return this.booking_notes_data;
  }

  set_booking_notes_data(value) {
    this.booking_notes_data.has_booking_notes = value;
    this.booking_notes_data.css = this.UiService.get_icon_css_class(value);
  }

  get_payment_general_data() {
    return this.payment_general_data;
  }

  set_payment_general_data(value) {
    this.payment_general_data.percentage = value;
    this.payment_general_data.css = this.UiService.get_counter_css_class(value);
  }

  get_delivery_general_data() {
    return this.delivery_general_data;
  }

  set_delivery_general_data(value) {
    this.delivery_general_data.percentage = value;
    this.delivery_general_data.css = this.UiService.get_counter_css_class(value);
  }

  get_main_infos_data() {
    return this.main_infos_data;
  }

  set_main_infos_data(value) {
    this.main_infos_data.percentage = value;
    this.main_infos_data.css = this.UiService.get_counter_css_class(value);
  }
}

OrderSidebarService.$inject = ['UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/services/order-sidebar.service.js